import { render, staticRenderFns } from "./DeficienciesList.vue?vue&type=template&id=066d86a1"
import script from "./DeficienciesList.vue?vue&type=script&lang=js"
export * from "./DeficienciesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports